import { Form } from '@mairistem/composants';
import { MULTI } from '@mairistem/comptabilite';
import { Combobox, Icon, Panel } from '@mairistem/finances-utils';
import React from 'react';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const CodeProduitLocalComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group className="panelRow">
					<Form.Field
						control={Combobox}
						data-testid="codeProduitLocalPanel"
						key="identifiantCodprodloc"
						label="Nature du produit"
						name="identifiantCodprodloc"
						onChange={handleChange}
						options={data?.codesProduitLocal}
						placeholder={data?.identifiantCodprodloc === MULTI ? MULTI : ''}
						search
						selection
						noResultsMessage="Aucun résultat trouvé"
						value={data?.identifiantCodprodloc ?? null}
						width={14}
					/>
					<Form.Input
						circular
						className="panelButton"
						control={Icon}
						name="magic"
						size="large"
						width={2}
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default CodeProduitLocalComponent;
